<template>
  <Transition name="fade">
    <div v-if="isEditor.isOpen" class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Category Editor </span>
        <span v-if="this.$store.state.freeEditor.mode == 'createCategory'" style="float: right">
          <argon-button @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Cancel</argon-button>
          <argon-button @click="addNewCategory()" color="success" size="md">Create Category</argon-button></span
        >
        <span v-if="this.$store.state.freeEditor.mode == 'viewCategory'" style="float: right">
          <argon-button @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Cancel</argon-button>
          <argon-button @click="patchCategory()" color="success" size="md">Save</argon-button></span
        >
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div v-if="this.$store.state.freeEditor.mode == 'createCategory'" class="col-md-8">
              <label for="example-text-input" class="form-control-label">Category Name</label>
              <argon-input type="text" id="newCategoryName" value="" placeholder="Enter new guest category name" />
            </div>

            <div v-if="this.$store.state.freeEditor.mode == 'viewCategory'" class="col-md-8">
              <label for="example-text-input" class="form-control-label">Category Name</label>
              <argon-input type="text" id="editCategoryName" :value="this.$store.state.freeEditor.name" placeholder="Enter new guest category name" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import ArgonInput from "@/components/ArgonInput.vue";
  import $ from "jquery";
  import ArgonButton from "@/components/ArgonButton.vue";
  import Multiselect from "@vueform/multiselect";
  import ArgonSwitch from "@/components/ArgonSwitch.vue";
  import "@vueform/multiselect/themes/default.css";
  import axios from "axios";
  import CKEditor from "@ckeditor/ckeditor5-vue";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

  export default {
    name: "template-editor",
    props: {
      cardBg: String,
      selectedOption: {},
    },
    components: {
      ArgonInput,
      ArgonButton,
      ArgonSwitch,
      Multiselect,
      ckeditor: CKEditor.component,
    },
    data() {
      return {
        templatedata: {},
        selects: {},
        categories: {},
        editor: ClassicEditor,
        editorConfig: {
          toolbar: ["bold", "italic", "|", "link"],
        },
        item: {
          id: 1,
          // both the commented out value and the
          // active value don't work
          // relatedItem: {
          //   value: 100,
          //   label: "test",
          // },
          relatedItem: 100,
        },
      };
    },
    computed: {
      isSuper() {
        return localStorage.getItem(sha256("isSuper").toString());
      },
      isEditor() {
        return this.$store.state.freeEditor;
      },
      gettemplateData() {
        return this.templatedata;
      },
      options() {
        return this.options;
      },
      getCategories() {
        return this.categories;
      },
    },
    methods: {
      getRoute() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
      patchCategory() {
        let data = {
          name: $("#editCategoryName").val(),
        };

        let JWTToken = localStorage.getItem("token");
        axios
          .patch("https://api.macra.co.id/mavent/guest-category/edit/" + this.$store.state.freeEditor.requestedrow, data, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then((res) => {
            alert(res.data.message);
            location.reload();
          })
          .catch((error) => {
            alert(error.message);
            alert(JWTToken);
          });
      },

      toggleResetPass() {
        console.log($("#changepwd").is("checked"));
        return (this.$store.state.freeEditor.resetPass = !this.$store.state.freeEditor.resetPass);
      },
      closeEditor() {
        this.$store.state.freeEditor.isOpen = false;
      },

      addNewCategory() {
        let data = {
          name: $("#newCategoryName").val(),
        };

        let JWTToken = localStorage.getItem("token");
        axios
          .post("https://api.macra.co.id/mavent/guest-category/add", data, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then((res) => {
            alert(res.data.message);
            location.reload();
          })
          .catch((error) => {
            alert(error.data.message);
            alert(JWTToken);
          });
      },
      createTemplatetemplate() {
        if ($("#newaccpwd").val() == $("#newaccpwdconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            full_name: $("#newfullname").val(),
            email: $("#newemail").val(),
            username: $("#newusername").val(),
            password: $("#newaccpwd").val(),
          };

          axios
            .post("https://api.macra.co.id/mavent/admin/add", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.status);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },

      encrypt(ele) {
        return sha256(ele);
      },
      getAdminData(row) {
        return (this.templatedata = this.$store.state.adminlist.rows[row]);
      },
      async fetchOptions(search) {
        console.log(search);
        // hits an API
        // /api/items/search?search=${search}
        return new Promise((resolve) => {
          setTimeout(() => {
            if (search) {
              resolve([
                {
                  value: 100,
                  label: "test",
                },
                {
                  value: 101,
                  label: "test2",
                },
              ]);
            } else {
              resolve([]);
            }
          }, 200);
        });
      },
    },
    mounted() {
      // if (this.$store.state.freeEditor.requestedrow != null) {
      //   this.getAdminData(this.$store.state.freeEditor.requestedrow);
      // }1
    },
  };
</script>
